var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":"Formas de pago","item-text":"nombre","item-value":"id","items":_vm.filteredItems,"prepend-icon":"mdi-cash-register"},model:{value:(_vm.selectedLocal),callback:function ($$v) {_vm.selectedLocal=$$v},expression:"selectedLocal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }